import React from 'react';
import styled from 'styled-components';
import { Avatar } from '@prezi/avatar';

import DetailsContainer from './Container';
import Name from './Name';
import Caption from './Caption';

type Props = {
    id?: string;
    firstName: string;
    lastName: string;
    caption?: string;
    size?: number;
};

const Container = styled.div`
    display: flex;
    align-items: center;
`;

export default ({ id, firstName, lastName, caption, size = 14 }: Props) => (
    <Container>
        <Avatar size={30} firstName={firstName} lastName={lastName} />
        <DetailsContainer id={id}>
            <Name size={size}>{`${firstName} ${lastName}`.trim()}</Name>
            <Caption size={size * 0.85}>{caption}</Caption>
        </DetailsContainer>
    </Container>
);
